// removed by extract-text-webpack-plugin
module.exports = {"Haricot":"#01A92B","White":"#FFFFFF","ScreenXSMax":"(max-width: 767px)","discountBadge":"G26785a G9c2edb","discountCopy":"G4952ad Gc4d7df"};